import { useContext } from 'react'
import { useQuery, useMutation } from 'react-query'
import { apiGet, apiPatch } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'


const getMunicipalityIssues = async (token, municipalityId, params) => {
  const url = `municipalities/${municipalityId}/issues`

  const data = await apiGet({ url, params, token })
  return data
}

export function useMunicipalityIssues({ params, options }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryFn = () => getMunicipalityIssues(token, municipality_id, params)
  const queryKey = ['municipalities', municipality_id, 'issues', params]

  return useQuery(queryKey, queryFn, {
    ...options
  })
}

const getMunicipalityIssue = async (token, id) => {
  const url = `issues/${id}`

  const data = await apiGet({ url, token })
  return data
}

export function useMunicipalityIssue({ id, options }) {
  const token = useContext(AuthContext)
  const queryFn = () => getMunicipalityIssue(token, id)
  const queryKey = `issues/${id}`

  return useQuery(queryKey, queryFn, {
    ...options
  })
}

const updateMunicipalityIssue = async (token, id, params) => {
  const url = `issues/${id}`
  const data = await apiPatch({ url, token, params })
  return data
}

export function useUpdateMunicipalityIssue({ id, params, options }) {
  const token = useContext(AuthContext)
  const mutationFn = () => updateMunicipalityIssue(token, id, params)

  return useMutation(mutationFn, {
    ...options
  })
}
